import { AxiosError, AxiosResponse } from "axios";
import { EnhancedAccount } from "library/accounts/types";
import { getTempCardLock, postTempCardLock } from "library/api/cards";
import { responses } from "library/api/service-cards.generated";
import { Product } from "library/hooks/types";
import { useState } from "react";
import { useMutation, useQuery } from "react-query";

export type AccountCardState = {
  account: EnhancedAccount;
  product: Product;
};

export type UseAccountState = {
  token: string;
  cardEndsWith: string;
  cardName: string;
  imageUrl: string;
};

export function useCardTempLock(token: string) {
  const [locked, setLocked] =
    useState<responses["cardLockResponse"]["schema"]["lock_status"]>(undefined);
  const getCardTempLock = useQuery<
    AxiosResponse<responses["cardLockResponse"]["schema"]>,
    AxiosError
  >(["tempCardLock", token], () => getTempCardLock(token), {
    onSuccess(response) {
      setLocked(response?.data?.lock_status);
    },
  });

  const updateCardTempLock = useMutation(
    (payload: boolean) =>
      postTempCardLock(token, {
        is_locked: payload,
      }),
    {
      onSuccess(response) {
        setLocked(response?.data?.lock_status);
      },
    },
  );

  return {
    isLoading: getCardTempLock.isLoading,
    isError: getCardTempLock.isError,
    locked,
    updateCardTempLock,
  };
}
